import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

import "./StopInvestigationDialog.scss"; // Import the SCSS file
import hexagon from "../../../assets/images/hexagon.svg";
// import { ReactComponent as hexagon } from "../../../assets/images/hexagon.svg";

const StopInvestigationModal = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      aria-labelledby="investigation-modal-title"
      className="notification"
    >
      {/* Dialog Title */}
      <DialogTitle
        id="investigation-modal-title"
        className="confirmation-dialog__title"
      >
        <img src={hexagon} alt="img" />
        {/* <SvgIcon
          component={hexagon}
          viewBox="0 0 54 54"
          sx={{ fontSize: 100 }} // or use width & height via sx
        /> */}

        <p className="confirmation-dialog__heading">Stop Investigation?</p>
      </DialogTitle>

      {/* Dialog Content */}
      <DialogContent>
        <p className="confirmation-dialog__message">
          The project debrief means you are handing in your investigator code
          and cannot return to the game. Do you really want to stop
          investigating?
        </p>
      </DialogContent>

      {/* Dialog Actions with Buttons */}
      <DialogActions className="confirmation-dialog__actions">
        <Button
          variant="contained"
          onClick={onConfirm}
          className="confirmation-dialog__button confirmation-dialog__button--stop"
        >
          Yes, I want to stop
        </Button>
        <Button
          variant="contained"
          onClick={onClose}
          className="confirmation-dialog__button confirmation-dialog__button--continue"
        >
          No, I want to continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StopInvestigationModal;
